(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barkops-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  if (!document.getElementById('boh-fonts')) {
    var link = document.createElement('link');
    link.id = 'boh-fonts'; link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barkops"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  if (!document.getElementById('bo-fonts')) {
    var link = document.createElement('link');
    link.id = 'bo-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
  document.querySelectorAll('.bo-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.closest('.bo-faq-list').querySelectorAll('.bo-faq-q').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.hidden = true;
      });
      if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); answer.hidden = false; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
